<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <dev-switch-plan-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm"></dev-switch-plan-form>
  </j-modal>
</template>

<script>

  import DevSwitchPlanForm from './DevSwitchPlanForm'
  export default {
    name: 'DevSwitchPlanModal',
    components: {
      DevSwitchPlanForm
    },
    data () {
      return {
        title: '',
        width: 1100,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style lang="less" scoped>
  ::v-deep {
    .ant-modal-body {
      /* title 和 footer 各占 55px */
      max-height: none;
      overflow-y: inherit;
    }
  }
</style>